import cn from 'classnames'
import React from 'react'
import ReactDOM from 'react-dom'
import { PannableArea } from '../components/PannableArea'

function PannableAttributes({
  wrapperElem,
  values = [],
  attributeClass = 'attribute',
  wrapperClass = 'attributes-outer',
  containerClass = 'attributes',
}) {
  return (
    <PannableArea wrapperElem={wrapperElem} wrapperClass={wrapperClass} containerClass={containerClass}>
      {values.map(({ text, className }, i) => {
        return <div key={i} className={cn(attributeClass, className)} dangerouslySetInnerHTML={{ __html: text }} />
      })}
    </PannableArea>
  )
}

window.PannableAttributes = {
  init: (elem, props) => {
    ReactDOM.render(<PannableAttributes {...props} wrapperElem={elem} />, elem)
  },
  deinit: (elem) => {
    ReactDOM.unmountComponentAtNode(elem)
  },
}
